import { z } from 'zod';
import { booleanQueryParamSchema, currencyCodeSchema, isoTimestampSchema, optionalTextSchema, uuidSchema, } from './common.js';
const last4Schema = z.string().regex(/^[0-9]{4}$/, 'must be the four last digits');
const expiresMonthSchema = z.int().min(1).max(12);
const expiresYearSchema = z.int().min(2000).max(2100);
const cardBodyShape = {
    label: z.string().min(1),
    last4: last4Schema.nullable(),
    brand: optionalTextSchema,
    expiresMonth: expiresMonthSchema.nullable(),
    expiresYear: expiresYearSchema.nullable(),
    currency: currencyCodeSchema.nullable(),
    color: optionalTextSchema,
};
export const cardSchema = z.object({
    id: uuidSchema,
    ...cardBodyShape,
    isArchived: z.boolean(),
    createdAt: isoTimestampSchema,
    updatedAt: isoTimestampSchema,
});
export const cardListSchema = z.array(cardSchema);
const cardBodySchema = z.object(cardBodyShape);
const hasWholeExpiryOrNone = (body) => (body.expiresMonth === null) === (body.expiresYear === null);
const checkedCardBodySchema = cardBodySchema.refine(hasWholeExpiryOrNone, {
    message: 'expiry month and year are given together or not at all',
    path: ['expiresMonth'],
});
export const createCardBodySchema = checkedCardBodySchema;
export const updateCardBodySchema = checkedCardBodySchema;
export const listCardsQuerySchema = z.object({
    includeArchived: booleanQueryParamSchema.default(false),
});
//# sourceMappingURL=card.js.map